import { ZfBox, ZfStack } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useRef } from 'react';
import ReactMarkdown from 'react-markdown';
import { useElementHeight } from '../../../hooks/useElementHeight';
import type { ITranslation } from '../../../interfaces/generic';
import { MultiLanguageInput } from './MultiLanguageInput';

interface IMultiLanguageMarkdownInputProps {
    language: string;
    value?: ITranslation;
    multiline?: boolean;
    rows?: number;
    onChange: (translation: ITranslation) => void;
}

export const MultiLanguageMarkdownInput: FunctionComponent<IMultiLanguageMarkdownInputProps> = ({ language, value, multiline, rows, onChange }) => {
    const markdownRef = useRef<HTMLZfBoxElement>(null);
    const height = useElementHeight(markdownRef, [value?.[language]]);

    return (
        <ZfStack key={language} direction="row" alignment="stretch">
            <MultiLanguageInput language={language} value={value} multiline={multiline} rows={rows} onChange={onChange} height={height} />
            <ZfBox
                ref={markdownRef}
                style={{
                    border: '1px solid var(--border-color-default-emphasis)',
                    borderRadius: '5px',
                    background: 'var(--bg-color-neutral-normal)',
                    flex: 1,
                    minHeight: 'var(--zf-input-size-min-height)',
                    paddingLeft: 'var(--padding-left-md)',
                    paddingRight: 'var(--padding-right-md)',
                    marginTop: 'var(--padding-top-lg)',
                    marginBottom: 'var(--padding-bottom-md)',
                    marginLeft: 'var(--padding-left-md)',
                }}
            >
                <ReactMarkdown>{value?.[language] ?? ''}</ReactMarkdown>
            </ZfBox>
        </ZfStack>
    );
};
